import {TimeLogger} from 'utils/logger';
import {normalizeError} from 'utils/normalize_error';

export async function saveItemToStorage(localForage: LocalForage, key: string, value: any) {
    await localForage.ready();

    try {
        await localForage.setItem(key, value);
    } catch (error: unknown) {
        TimeLogger.error({
            error: normalizeError(error),
            message: 'saveItemToStorage: unknown error',
        });
    }
}
